import React, { useState } from 'react';

const ItemSubcategory = ({
  title = '',
  itemCountInput = null, // Changed from false to null (React node)
  children
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {   
    setExpanded(prev => !prev);
  };

  return (
    <div className="mb-3 border rounded p-2" style={{ backgroundColor: '#edfbed' }}>
      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={toggleExpanded}
        style={{ cursor: 'pointer' }}
      >
        <h6 className="mb-0 text-black fs-5">{title}</h6>

        {itemCountInput && (
          <div onClick={e => e.stopPropagation()} style={{ maxWidth: '150px', width: '100%' }}>
            {itemCountInput}
          </div>
        )}
      </div>

      {/* Body Content */}
      {expanded && (
        <div
          className="mt-3 bg-white rounded p-3"
          style={{
            maxHeight: '350px',
            overflowY: 'auto',
            overflowX: 'hidden'
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default ItemSubcategory;
